export default "__VITE_ASSET__DRy9zhdw__"